<template>
    <div class="loader title"></div>
</template>

<script>
export default { name: 'Loader' };
</script>
